module.exports = __webpack_public_path__ + "static/media/sitelock.b5e3e7ac.svg";